import React from "react";
import Navbar from "../Components/Navbar";
import '../Styles/AboutHistory.scss';
import {Helmet} from "react-helmet";
import Footer from "../Components/Footer.js";

function AboutHistory() {
   return (
      <div>
         <Helmet>
            <title>History - Camp Connect</title>
         </Helmet>
         <div className="historyPageOne">
            <Navbar/>
            <div className="historyPageOneTitle">
               <div className="historyPageOneTitleText">
                  <>The Camp's Story</>
               </div>
            </div>
         </div>

         <div className="historyPageTwo">
            <div className="historyPageTwoText">
                  <div className="historyPageTwoTitleText">
                     <>Beginning</>
                  </div>

                  <div className="historyPageTwoInfoTextOuterContainer">
                     <div className="historyPageTwoInfoText">
                        <div className="historyPageTwoInfoTextInnerContainer">
                        In the fall of 2022, a group of senior software development students saw the 
                        need for a modern camp ministry website platform that camp ministries could 
                        utilize to modernize their online presence and registration platform. With 
                        this need in mind, the vision for Camp Connect was born, and work began to make 
                        this vision a reality.
                        </div>
                     </div>
                  </div>

            </div>
         </div>

         <div className="historyPageThree">
            <div className="historyPageThreeText">
                  <div className="historyPageThreeTitleText">
                     <>Growth</>
                  </div>

                  <div className="historyPageThreeInfoTextOuterContainer">
                     <div className="historyPageThreeInfoText">
                        <div className="historyPageThreeInfoTextInnerContainer">
                        Throughout the fall of 2022, and into the winter and spring of 2023, 
                        the Camp Connect team worked diligently to develop a modern, user-friendly 
                        platform. At the end of the fall semester, the team had completed much of the 
                        backend and database design logic. After a brief winter break, the Camp Connect 
                        team reconvened to build upon their previous work and were able to quickly complete 
                        a usable registration portal and polished user interface.
                        </div>
                     </div>
                  </div>
            </div>
         </div>

         <div className="historyPageFour">
            <div className="historyPageFourText">
                  <div className="historyPageFourTitleText">
                     <>Leadership</>
                  </div>

                  <div className="historyPageFourInfoTextOuterContainer">
                     <div className="historyPageFourInfoText">
                        <div className="historyPageFourInfoTextInnerContainer">
                        The Camp Connect project could not have been accomplished were it not for 
                        the diligence, expertise, and collaboration of each member of the Camp Connect team. 
                        The Camp Connect team is composed of Isaac Patton, who served as a full stack 
                        developer and the database administrator; Jonathan Palchevskiy, who served as a 
                        front-end developer and headed up quality assurance and testing; Levi Stump, who 
                        served as the assistant team leader and full stack developer; and Grant Stump, 
                        who served as the team leader for Camp Connect and as a middleware and backend 
                        developer. The Camp Connect team also is grateful for the work of Ethan Huckabee, 
                        who was instrumental in the development of the registration portal. These individuals’ 
                        diligence and commitment to the Camp Connect project allowed it to be a successful 
                        platform that will effectively equip ministries to modernize their online presence.
                        </div>
                     </div>
                  </div>
            </div>
         </div>

      <Footer/>
      </div>
   )
};

export default AboutHistory;
